<div class="card-header bg-light">
  <h4 class="card-title mb-0"> {{titulo}} Formulário</h4>
</div>
<div class="card-body wrapper ">
  <div class="mb-1">
    <label for="descricaoInput" class="form-label">Descrição</label>
    <div class="input-group">
      <input
        type="text"
        class="form-control"
        id="descricaoInput"
        placeholder="Digite uma descrição..."
        aria-label="Descrição"
        [(ngModel)]="descricao"
        name="descricaoInput"
        [disabled]="visualizar"
      />
      <button class="btn btn-success" *ngIf="!visualizar" type="button" (click)="adicionarItem()">
        <i class="fa fa-plus"></i>
      </button>
    </div>
  </div>

  <table class="table mt-3">
    <thead>
    <tr>
      <th>Item</th>
      <th>Descrição</th>
      <th>Ação</th>
    </tr>
    </thead>
    <tbody>
    <ng-container *ngIf="dadosItem?.amostraFormularioItens as itens">
      <tr *ngFor="let item of itens; let i = index; trackBy: trackByIndex">
        <td>{{ i + 1 }}</td>
        <td>{{ item.descricao }}</td>
        <td>
          <button class="btn btn-link p-0" *ngIf="!visualizar" (click)="excluir(item)" title="Excluir">
            <i class="fa fa-trash" style="color: red;"></i>
          </button>
        </td>
      </tr>
    </ng-container>
    </tbody>
  </table>

</div>
<div class="card-footer">
  <button class="btn btn-primary btn-sm" *ngIf="!visualizar" [disabled]="dadosItem?.amostraFormularioItens.length === 0" (click)="salvar()">Salvar</button>
  <button class="btn btn-default btn-sm ml-2" (click)="cancelar()">
    Fechar
  </button>
</div>
